import React, { useState, useEffect } from 'react';
import Footer from '../../layout/footer/footer'
import Profile from '../../assets/icons/profile.svg'
import { Link,useNavigate } from 'react-router-dom';

function Faq() {
    const [customerData, setCustomerData] = useState(null);
    const navigate = useNavigate(); // useNavigate for navigation without refresh

    useEffect(() => {
        setCustomerData(JSON.parse(localStorage.getItem('userData')));
    }, []);
    return (
        <div className='bg-[#E5ECFF]' style={{ height: '100vh' }}>
            <div className='container pageList  pt-3'>
                <div className=''>
                    <button className='btn btn-primary d-flex justify-content-start align-items-center w-100' onClick={() => {
                        if (customerData == null) { navigate('/login') } else {
                            navigate('/panel')
                        }
                    }}>
                        <img src={Profile} style={{ marginLeft: '3px' }} alt="Profile" />
                        {customerData == null ? 'ورود' : customerData.fullName}
                    </button>
                    <Link to="/activation" className=''>
                        <button className='btn mt-3 btn-light shadow-sm text-base d-flex justify-content-start align-items-center w-100' >
                            شارژ و فعالسازی
                        </button>
                    </Link>
                    <Link to="/about-us">
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100' >
                            درباره ما
                        </button>
                    </Link>

                    {/* <Link to="/contact-us">
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100' >
                            ارتباط با ما
                        </button>
                    </Link> */}

                    <Link to="/faq">
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100' >
                            سوالات متداول
                        </button>
                    </Link>

                    {/* <Link >
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100'>
                            فهرست و درخواست نمایندگی
                        </button>
                    </Link> */}

                    <Link to="/rules">
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100'>
                            شرایط، مقررات و حریم خصوصی کاربران
                        </button>
                    </Link>
                    
                    <Link to="/catalog">
                        <button className='btn btn-light shadow-sm text-base mt-2 d-flex justify-content-start align-items-center w-100'>
                            کاتالوگ
                        </button>
                    </Link>


                </div>

            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </div>
    )
}

export default Faq